import { render, staticRenderFns } from "./AppendicesComponent.vue?vue&type=template&id=6abafec4&"
import script from "./AppendicesComponent.vue?vue&type=script&lang=js&"
export * from "./AppendicesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports